import { clsx } from 'clsx';
import { betaTag, betaTagVariants } from './beta-tag.css.ts';

export const BetaTag = ({
  size = 'sm',
  children = 'Beta',
}: {
  size?: keyof typeof betaTagVariants;
  children?: React.ReactNode;
}) => {
  return <div className={clsx(betaTag, betaTagVariants[size])}>{children}</div>;
};
